import React, {Component} from "react"
import styles from "./Footer.module.css"
import naaLogo from "../Header/parts/img/naa-logo.webp"

const campuses = [
    {
        id: 1,
        region_id: 1,
        name: "New England",
        code: "New England",
        address: "130 Baker Ave Ext. Concord, MA 01742",
        state: "",
        phone: "781-274-8448",
        school_code: "",
        region: {
            id: 1,
            state: "Massachusetts",
            region: "Massachusetts"
        }
    },
    {
        id: 2,
        region_id: 2,
        name: "Tampa Bay",
        code: "Tampa Bay",
        address: "6225 Ulmerton Rd. Clearwater, FL 33760",
        state: "",
        phone: "727-531-2080",
        school_code: "",
        region: {
            id: 2,
            state: "Florida",
            region: "Florida"
        }
    }
]

const social = [
    {
        id: 1,
        name: "Facebook",
        link: "https://www.facebook.com/NAA.EDU",
        icon: "fa fa-facebook"
    },
    {
        id: 2,
        name: "Instagram",
        link: "https://instagram.com/naaedu",
        icon: "fa fa-instagram"
    },
    {
        id: 3,
        name: "Twitter",
        link: "https://twitter.com/naaedu",
        icon: "fa fa-twitter"
    },
    {
        id: 4,
        name: "Youtube",
        link: "https://www.youtube.com/naaedu",
        icon: "fa fa-youtube-play"
    }
]

interface Props {}

export class Footer extends Component<Props, {}> {
    public render() {
        return (
            <footer className={styles.root}>
                <div className={styles.wrapper}>
                    <div>
                        <div>
                            <img src={naaLogo} alt="naa-logo" />
                        </div>
                        <div className={styles.social}>
                            {social.map(({id, link, icon}) => (
                                <a
                                    href={link}
                                    className={icon}
                                    key={id}
                                    target="_blank"
                                    rel="noopener noreferrer">
                                    {""}
                                </a>
                            ))}
                        </div>
                    </div>
                    <div className={styles.campuses}>
                        <h5>
                            <strong>CAMPUS LOCATION</strong>
                        </h5>
                        {campuses.map(({code, address, phone, id}) => (
                            <div className={styles.campusContainer} key={id}>
                                <div className={styles.code}>
                                    <strong>{code}</strong>
                                </div>
                                <div className={styles.address}>{address}</div>
                                <div className={styles.phone}>
                                    <strong>Ph:</strong> {phone}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </footer>
        )
    }
}
